import request from '@/service/request'

/**
 * 脱敏数据解密服务
 */
export class sensitiveDataService {
  /**
   * 解密敏感字段
   * @param params SensitiveDataDecryptDTO
   * @returns SensitiveDataDecryptVO
   */
  static decrypt(params: {
    fieldValue: string
    queriedFieldName: string
    bizId?: string
    systemName?: string
    menuName?: string
    uri?: string
    moduleName?: string
  }): Promise<any> {
    return request.post('/yl-jmsmy-tmp-station-ibk-api/sensitive/decrypt', params)
  }
}
